import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-page-container',
  standalone: true,
  template: '<main class="page-container"><ng-content /></main>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageContainerComponent {}
